<div>
    <div class="title">
        <h4>{{ betbuilderMessages?.OverlayTitle }}</h4>
        <div class="betbuilder-theme-info" (click)="openHowToPopup()">
            <vn-icon name="theme-info" size="16" />
        </div>
    </div>
    <div class="subtitle">
        <span>{{ headerParticipants }}</span>
        <span>•</span>
        <span>{{ date }}</span>
    </div>
</div>
<button class="btn btn-secondary btn-md betbuilder-overlay--header-btn close-overlay" (click)="closeOverlayAndKeepPick()">
    {{ betbuilderMessages?.OverlayClose }}
</button>
